export const initialState = {
  searchResult: null,
  userMCNmapping: false,
  userMCNList: null,
  selectedEtrackUser: null,
};
